
import React from 'react';
import { motion } from 'framer-motion';
import { Brain, TrendingUp, TrendingDown, Minus, AlertTriangle } from 'lucide-react';

export default function AnalyticsPanel({ analysis }) {
    if (!analysis) return null;

    const { riskScore, riskLevel, factors, prediction, anomaly } = analysis;

    const getTrendIcon = (trend) => {
        if (trend === 'rising') return <TrendingUp color="#ef4444" />;
        if (trend === 'falling') return <TrendingDown color="#10b981" />;
        if (trend === 'flash_flood') return <TrendingUp color="#ef4444" size={32} />;
        return <Minus color="#94a3b8" />;
    };

    return (
        <div className="card glass-effect mt-4">
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 15 }}>
                <Brain size={24} color="#60a5fa" />
                <h3>Análisis Inteligente (AI)</h3>
            </div>

            {/* Risk Meter */}
            <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                    <span>Índice de Riesgo</span>
                    <span style={{ fontWeight: 'bold', color: riskLevel === 'critical' ? '#ef4444' : '#10b981' }}>
                        {riskScore}/100
                    </span>
                </div>
                <div style={{ height: 10, background: '#334155', borderRadius: 5, overflow: 'hidden' }}>
                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: `${riskScore}%` }}
                        style={{
                            height: '100%',
                            background: `linear-gradient(90deg, #10b981 0%, #f59e0b 50%, #ef4444 100%)`
                        }}
                    />
                </div>
            </div>

            {/* Predictions */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
                <div className="stat-box" style={{ background: 'rgba(255,255,255,0.05)', padding: 10, borderRadius: 8 }}>
                    <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Tendencia (Nowcasting)</span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 5 }}>
                        {getTrendIcon(prediction.trend)}
                        <span style={{ fontWeight: 'bold' }}>
                            {prediction.trend === 'flash_flood' ? 'INUNDACIÓN REPENTINA' :
                                prediction.trend === 'rising' ? 'Subiendo' :
                                    prediction.trend === 'falling' ? 'Bajando' : 'Estable'}
                        </span>
                    </div>
                </div>
                <div className="stat-box" style={{ background: 'rgba(255,255,255,0.05)', padding: 10, borderRadius: 8 }}>
                    <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Predicción +30min</span>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', marginTop: 5 }}>
                        ~{prediction.t30} cm
                    </div>
                </div>
            </div>

            {/* Explainable Factors */}
            {factors.length > 0 && (
                <div style={{ background: 'rgba(245, 158, 11, 0.1)', padding: 10, borderRadius: 8 }}>
                    <span style={{ fontSize: '0.8rem', color: '#fbbf24', fontWeight: 'bold' }}>⚠️ Factores de Riesgo Detectados:</span>
                    <ul style={{ margin: '5px 0 0 20px', fontSize: '0.9rem', color: '#e2e8f0' }}>
                        {factors.map((f, i) => <li key={i}>{f}</li>)}
                    </ul>
                </div>
            )}

            {/* Anomaly Warning */}
            {anomaly && (
                <motion.div
                    initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                    style={{ marginTop: 10, padding: 10, background: 'rgba(239, 68, 68, 0.2)', borderRadius: 8, display: 'flex', alignItems: 'center', gap: 10, color: '#fca5a5' }}
                >
                    <AlertTriangle size={20} />
                    <span style={{ fontSize: '0.9rem' }}>Anomalía detectada. Posible error en sensor.</span>
                </motion.div>
            )}
        </div>
    );
}
